export default "__VITE_ASSET__T60qhNhk__"